import React from 'react';
import '.././css/navigation.css';
import logo from '.././images/novu512.png'
import { LinkComponent } from './Utilities';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { Link } from 'react-router-dom';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { blue } from '@material-ui/core/colors';
import faqRef from '.././App.js';


const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      [theme.breakpoints.only('sm')]: {
        marginRight:theme.spacing(0),
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    },
    logo: {
      height: 100,
      width: 100, 
    },
  }));

  const theme = createMuiTheme({
    palette: {
      primary: {
        // Purple and green play  0f1116 nicely together.
        main: "#0f1116",
      },
      secondary: {
        main: '#1abce57c',
      },
    },
  });

  

function Navigation() {
    const classes = useStyles();

    const handleScroll = ref => {
      window.scrollTo({
        behavior: "smooth"
      });
    };
    /* classes.root - HVILKEN CLASS ER DET, hvordan kan jeg få den i css */
    return (
    <div className={classes.root}> 
        <ThemeProvider theme={theme}>
        <AppBar position="sticky" color='primary' className="dark">
        <Toolbar>
        <Typography  className={classes.title}>
          <Link to="/">
            <img src={logo} alt="logo" className={classes.logo}/>
          </Link>
        </Typography>
            <IconButton>
              {/* {Hambruger} */}
            <Link className="fancyButton" to="/">
                  <span> </span> 
                  <span> </span>
                  <span> </span>   
                  <span> </span>
                  <b>Spil Hosting</b>  
            </Link>
            </IconButton>
            <IconButton>
            <Link className="fancyButton" to="/pages/about_us">
                  <span> </span> 
                  <span> </span>
                  <span> </span>   
                  <span> </span>
                  <b>Om os</b>
            </Link>
            </IconButton>
            <IconButton>
            <Link className="fancyButton" onClick={() => handleScroll()}>
                  <span> </span> 
                  <span> </span>
                  <span> </span>   
                  <span> </span>
                  <b>FAQ</b>
            </Link>
            </IconButton>
            <IconButton>
            <Link className="fancyButton" to="/pages/contact_us">
                  <span> </span> 
                  <span> </span>
                  <span> </span>   
                  <span> </span>
                  <b>Kontakt os</b>
            </Link>
            </IconButton>
            <IconButton>
            <Link className="fancyButton" to="/external/client_area">
                  <span> </span> 
                  <span> </span>
                  <span> </span>   
                  <span> </span>
                  <b>Client login</b>
            </Link>
            </IconButton>
            <IconButton>
            <Link className="fancyButton" to="/external/server_pane">
                  <span> </span> 
                  <span> </span>
                  <span> </span>   
                  <span> </span>
                  <b>Panel login</b>
            </Link>
            </IconButton>
        </Toolbar>
      </AppBar>
      </ThemeProvider>
    </div>

  );

    }

export default Navigation;